import { Toaster, toast as sonnerToast } from 'sonner';

/**
 * App-wide toast container. Mount once in `AppShell` so children can call
 * `toast.success(...)` etc. without provider plumbing.
 *
 * Positioned top-right on desktop, top-center on mobile via Sonner's default
 * responsive layout. Respects `prefers-reduced-motion`.
 */
export function ToastProvider(): JSX.Element {
  return (
    <Toaster
      position="top-right"
      theme="dark"
      richColors
      closeButton
      expand={false}
      toastOptions={{
        className: 'rounded-card border border-fc-line bg-fc-paper text-fc-ink shadow-md',
        descriptionClassName: 'text-fc-muted',
        duration: 5000,
      }}
    />
  );
}

type ToastInput = {
  title: string;
  description?: string;
  durationMs?: number;
};

/**
 * Imperative toast API. Use in handlers, mutations, error boundaries.
 *
 * @example
 *   toast.success({ title: 'Pago confirmado', description: 'QR generado.' });
 *   toast.error({ title: 'Pago rechazado', description: e.message });
 *   toast.info({ title: 'Tu carrito expira en 2 minutos.' });
 */
// eslint-disable-next-line react-refresh/only-export-components -- API imperativa de toasts; no es un componente y no afecta fast-refresh en runtime.
export const toast = {
  success: ({ title, description, durationMs }: ToastInput): void => {
    sonnerToast.success(title, { description, duration: durationMs });
  },
  error: ({ title, description, durationMs }: ToastInput): void => {
    sonnerToast.error(title, { description, duration: durationMs });
  },
  info: ({ title, description, durationMs }: ToastInput): void => {
    sonnerToast(title, { description, duration: durationMs });
  },
};
